<textarea #editorContainer></textarea>
<div class="editor-security-notice">
  <mat-icon>info</mat-icon>
  <span>For security purposes, certain HTML elements and attributes may be sanitised when content is saved.</span>
</div>
